<template>
  <div class="home">
    <template v-if="showOverlay">
      <div class="blocked-showcase">
        <h2 class="overlay-title">Conheça o novo sistema para gravação de chassi</h2>
        <video src="/novo-sistema.mp4" autoplay loop muted controls></video>
        <p class="overlay-description">Para ter acesso ao sistema de gravação atualizado entre em contato através do whatsapp <br><strong>(49)98501-9666</strong>, ou clique no botão abaixo para chamar direto no whatsapp.</p>
        <div class="overlay-buttons">
          <a href="https://wa.me/5549985019666?text=Ol%C3%A1%2C%20tenho%20interesse%20no%20novo%20sistema%20para%20grava%C3%A7%C3%A3o%20de%20chassi" target="_blank" class="btn btn-success btn-whatsapp">
            <i class="fab fa-whatsapp mr-2"></i>Fale Conosco
          </a>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="text">
        <h3>Sistema para gravação de chassi em vidros automotivos</h3>
        <div>
          Os vidros de reposição também devem conter o número do chassi.
          <br>
          A ausência do número do chassi nos vidros é considerada infração grave e está sujeita a multa de <strong>R$195,23</strong> e retenção do veículo.
          <br><br>
          <strong>1º </strong>Selecione a fonte desejada no menu Fontes.
          <br>
          <strong>2º </strong>Informe o chassi.
          <br>
          <strong>3º </strong>Selecione o tipo de impressora.
          <br>
          <strong>4º </strong>Clique em Imprimir.
        </div>
      </div>
      <div class="form">
        <label>Chassi</label>
        <input ref="inputChassi" :style="{ 'font-family': font }" type="text" class="form-control input-chassi">
        <label class="label">{{ label }}</label>
        <br>
        <button @click="printChassiMatricial()" class="btn btn-primary mr-3"><img src="../../assets/img/printer-matricial-24.png" class="pr-2">Matricial</button>
        <button @click="printChassiTermica()" class="btn btn-success"><img src="../../assets/img/printer-termica-24.png" class="pr-2">Térmica</button>
      </div>
      <div class="banner">
          <router-link to="/productsList">
            <img
              v-if="announcementStart"
                :src=announcementStart
                alt="Foto Anúncio"
            >
          </router-link>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
    font: '',
    label: '',
    chassi: '',
    radio: 'Matricial',
    announcementStart: '',
    announcementRef: null,
    showOverlay: true
  }),
  methods: {
    readFont () {
      if (this.$route.params.font) {
        this.font = this.$route.params.font
        this.label = this.$route.params.label
        this.chassi = this.$route.params.chassi
        if (this.chassi) {
          this.$refs.inputChassi.value = this.chassi
        }
      }
    },
    printChassiMatricial () {
      const inputChassi = this.$refs.inputChassi.value.toUpperCase()

      if (inputChassi) {
        this.$router.push({ name: 'printMatricial', params: { font: this.font, label: this.label, chassi: inputChassi } })

        this.readFont()
      } else {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar o chassi.',
          type: 'warning'
        })
      }
    },
    printChassiTermica () {
      const inputChassi = this.$refs.inputChassi.value.toUpperCase()

      if (inputChassi) {
        this.$router.push({ name: 'printTermica', params: { font: this.font, label: this.label, chassi: inputChassi } })

        this.readFont()
      } else {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar o chassi.',
          type: 'warning'
        })
      }
    },
    getAnnouncementStart () {
      this.announcementRef = this.$firebase.database().ref('parameters/announcementStart')
      this.announcementRef.on('value', (data) => {
        this.announcementStart = data.val()
      })
    }
  },
  mounted () {
    this.getAnnouncementStart()
    this.readFont()
    this.$refs.inputChassi.focus()
  },
  beforeDestroy () {
    if (this.announcementRef) this.announcementRef.off()
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding: 40px 60px;
  .text h3 {
    color: #0082e6;
    margin-bottom: 15px;
  }
  .text div {
    font-size: 18px;
  }
  .form {
    margin-top: 15px;
  }
  .form .input-chassi {
    width: 320px;
    text-transform: uppercase;
    font-size: 22px;
    font-weight: bold;
    color: #000000;
    letter-spacing: 3px;
    margin-bottom: 10px;
  }
  .form .radio-printer {
    margin-right: 5px;
  }
  .form button {
    padding: 7px 25px;
  }
  .form .label {
    position: absolute;
    left: 178px;
    font-size: 12px;
    font-style: italic;
    color: rgb(116, 116, 116);
    text-align: end;
    width: 200px;
  }
  .banner {
    margin-top: 25px;
    text-align: center;
  }
}
@media (min-height: 755px) {
  .home {
    .banner {
      position: absolute;
      bottom: 160px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
// PARA NÃO SAIR NO FUNDO DA IMPRESSAO ERRO DO CHROME
@media print {
      .home  {
      display: none !important;
    }
  }
</style>
